import { render, staticRenderFns } from "./sendCoupon.vue?vue&type=template&id=81f2ba18&"
import script from "./sendCoupon.vue?vue&type=script&lang=js&"
export * from "./sendCoupon.vue?vue&type=script&lang=js&"
import style0 from "./sendCoupon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports